<template>
  <b-modal
    id="create-qr-code-modal"
    title="QRCode Create Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <template #modal-title>
      <h2 class="m-0">QRCode Create</h2>
    </template>
    <validation-observer ref="createUserFormValidation">
      <b-form @submit.prevent enctype="multipart/form-data">
        <b-form-group label-for="site">
          <template #label>
            Site <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="site"
            placeholder="Select Site"
            :options="sites"
            autoscroll
            :clearable="true"
            @input="fetchBuildings()"
            required
          ></v-select>
        </b-form-group>


        <b-form-group label-for="building">
          <template #label>
            Building <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="building"
            placeholder="Select Site"
            :options="buildings"
            autoscroll
            :clearable="true"
            @input="fetchFloors()"
            required
          ></v-select>
        </b-form-group>

        <b-form-group label-for="floor">
          <template #label>
            Floor <span class="text-danger">*</span>
          </template>
          <v-select
            label="floor_no"
            v-model="floor"
            placeholder="Select Floor"
            :options="floors"
            autoscroll
            :clearable="true"
            @input="fetchFlats()"
            required
          ></v-select>
        </b-form-group>

        <!-- <b-form-group label-for="flat">
          <template #label>
            Flat (Optional)
          </template>
          <v-select
            label="flat_no"
            v-model="flat"
            placeholder="Select Flat"
            :options="flats"
            autoscroll
            :clearable="true"
            required
          ></v-select>
        </b-form-group> -->


        <b-form-group class="mt-2 text-right">
          <b-button
            type="submit"
            variant="primary"
            pill
            class="mr-1"
            @click="submit"
          >
            Save
          </b-button>
          <b-button
            type="reset"
            variant="outline-secondary"
            @click="reset"
            pill
          >
            Reset
          </b-button>
        </b-form-group>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  mixins: [util],
  data() {
    return {
      required,
      name: "",
      qrcode_type: "",
      regex: /^[a-zA-Z ]*$/,
      site: null,
      building: null,
      flat: null,
      floor: null,
      sites: [],
      buildings: [],
      flats : [],
      floors : [],
      qr_types: [
        {
          name : "Visitor",
          value: "Visitor"
        },
        {
          name : "Resident",
          value: "Resident"
        },
      ],
      qr_type: "",
    };
  },
  methods: {
    ...mapActions({
      createQRCode: "appData/createQRCode",
      getFlatsDDL: "appData/getFlatsDDL",
      getFloorsDDL: "appData/getFloorsDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
      getSitesDDL: "appData/getSitesDDL",
    }),

    async submit() {
      try {
        
        const formData = new FormData();
        formData.append("site", this.site.id);
        formData.append("building", this.building.id);
        formData.append("floor", this.floor.id);
        
        // if (this.flat){
        //   formData.append("flat", this.flat.id);
        // }
        
        formData.append("created_by", this.getLoggedInUser.id);
        formData.append("updated_by", this.getLoggedInUser.id);
        console.log("formData", formData)
        const res = await this.createQRCode(formData);
        if (res.status === 201) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "QRCode Created Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("create-qr-code-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },

    async fetchBuildings(){
      const buildings =  await this.getBuildingsDDL();
      this.buildings = buildings.data;
      this.building = "";
      this.floor = "";
      this.flat = "";
       if (!this.site) {
        this.buildings = [];
        return;
      }
      this.buildings = this.buildings.filter(building => building.site === this.site.id);      
    },

    async fetchFloors(){
      const floors =  await this.getFloorsDDL();
      this.floors = floors.data;
      this.floor = "";
      this.flat = "";
       if (!this.building) {
        this.floors = [];
        return;
      }
      this.floors = this.floors.filter(floor => floor.building === this.building.id);   
    },

    async fetchFlats(){
      const flats =  await this.getFlatsDDL();
      this.flats = flats.data;
      this.flat = "";
       if (!this.floor) {
        this.flats = [];
        return;
      }
      this.flats = this.flats.filter(flat => flat.floor === this.floor.id);   
    },

    

    reset() {
      this.name = "";
      this.location = "";
      this.description = "";
      this.files = null;
      this.status = "";
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
  async mounted(){
    const sites =  await this.getSitesDDL();
    this.sites = sites.data;
  },
};
</script>

<style></style>
